import { ReactNode } from 'react';
import { Card, CardBody } from 'reactstrap';

const WarningCard = ({ message }: { message: ReactNode }) => {
  return (
    <Card className="bg-light fs-4 fst-italic">
      <CardBody>
        <i className="fe fe-alert-circle me-2"></i>
        <span className="">{message}</span>
      </CardBody>
    </Card>
  );
};

export default WarningCard;
